import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs';
import { permissionsApis } from '../../constants/permissions-apis';

@Injectable({
    providedIn: 'root',
})
export class PermissionsService {
    constructor(private httpClientService: HttpClientService) {}

    /* Get Permissions */
    getPermissions(): Observable<any> {
        return this.httpClientService.get(`${permissionsApis.permissions}?skip=0&limit=200`);
    }

    /* Post Permissions */
    postPermissions(payload: any): Observable<any> {
        return this.httpClientService.post(
            permissionsApis.permissions,
            payload
        );
    }

    /* Edit Permissions */
    editPermissions(payload: any): Observable<any> {
        return this.httpClientService.put(permissionsApis.permissions, payload);
    }

    /* Delete Permissions */
    deletePermissions(): Observable<any> {
        return this.httpClientService.delete(permissionsApis.permissions);
    }
}
